import { getTimelineTotalSpaceByMode, isDatesInTheSamePeriod, repeatConductInRows } from '../helpers'
import { IHealthProceduresConduct } from '~/interfaces'
import { IAdmissionRowSlots, TimelinePeriodTypes } from '~/interfaces/timeline'

export const splitAdmissionsPeriod = (
  admissions: IAdmissionRowSlots[],
  mode: TimelinePeriodTypes
): IAdmissionRowSlots[] => {
  let eachAdmissionPerRow: IAdmissionRowSlots[] = []

  admissions.forEach(admission => {
    if (isDatesInTheSamePeriod(admission, mode)) {
      eachAdmissionPerRow = [...eachAdmissionPerRow, { ...admission }]
      return
    }

    const dividedAdmissions = repeatConductInRows(admission as IHealthProceduresConduct, mode) as IAdmissionRowSlots[]
    eachAdmissionPerRow = [...eachAdmissionPerRow, ...dividedAdmissions]
  })

  return eachAdmissionPerRow
}

export const getWidthOfSlotByRange =
  (startDate: string, endDate: string) =>
  (mode: TimelinePeriodTypes): number => {
    const totalSpace = getTimelineTotalSpaceByMode(mode)

    if (mode === 'years') {
      const onceMonthWidth = 100 / totalSpace
      const startDateMonth = Number(new Date(startDate).getMonth())
      const endDateMonth = Number(new Date(endDate).getMonth())
      const rangeDistance = endDateMonth - startDateMonth + 1

      return Math.floor(rangeDistance * onceMonthWidth)
    }

    if (mode === 'months') {
      const startDateFormat = new Date(startDate)
      const totalDaysInMonth = new Date(startDateFormat.getFullYear(), startDateFormat.getMonth() + 1, 0).getDate()
      const onceDayWidth = 100 / totalDaysInMonth
      const startDateDay = Number(startDateFormat.getDate()) - 1
      const endDateDay = Number(new Date(endDate).getDate())
      const rangeDistance = endDateDay - startDateDay

      return Math.round(rangeDistance * onceDayWidth)
    }

    if (mode === 'weekly') {
      const startDateWeek = new Date(startDate).getDay()
      const endDateWeek = new Date(endDate).getDay()
      const rangeDistance = endDateWeek - startDateWeek + 1

      return Math.ceil((rangeDistance * 100) / (totalSpace + 1))
    }

    if (mode === 'days') {
      const onceHourWidth = 100 / totalSpace
      const startDateHour = Number(new Date(startDate).getHours())
      const startDateMinutes = Number(new Date(startDate).getMinutes()) / 60
      const endDateHour = Number(new Date(endDate).getHours())
      const endDateMinutes = Number(new Date(endDate).getMinutes()) / 60

      const rangeDistance = Math.round(endDateHour + endDateMinutes) - Math.floor(startDateHour + startDateMinutes)

      return Math.round(rangeDistance * onceHourWidth)
    }

    return 0
  }
